import axios from 'axios';
import { authHeaders } from './authService';
import API_BASE from './apiBase';

// all container reads and writes go through the authenticated, scoped API
const API_URL = `${API_BASE}/containers`
const NEW_API_URL = API_URL
const withAuth = async (extra = {}) => ({ headers: { ...(await authHeaders()), ...extra } })

const fetchContainerData = async (bounds) => {
    try {
        const url = bounds ? `${NEW_API_URL}?bounds=${bounds.boundsString}` : NEW_API_URL;
        console.log(`Fetching data: ${url}`)
        // identify the caller so the API can scope results per login
        const response = await axios.get(url, { headers: await authHeaders() });

        const data = response.data;
        let result= data.containers.map(ca => {
            const res = {
                containerId: ca.containerId,
                ...ca.data,
                lat: ca.lat,
                lng: ca.lng,
                times: {}
            }
            res.customerName = res.customerName || "";
            res.containerId = res.containerId || "";
            res.size = res.size||"";
            res.fullness = +res.fullness||0
            return res;
        })
        result = result.filter(e => {
            return  e.deleted !== 'true' && e.deleted !== true
        });
        return result
    } catch (error) {
        throw new Error(error.response ? `HTTP error! status: ${error.response.status}` : error.message);
    }
};

const deleteContainer = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`, await withAuth());
        return response.data;
    } catch (error) {
        throw new Error(error.response ? `HTTP error! status: ${error.response.status}` : error.message);
    }
};

const updateContainer = async (id, updatedData) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, {
            containerId: id,
            data: {
                geo: updatedData.geo,
                thumbnail: updatedData.thumbnail,
                address: updatedData.address,
                size: updatedData.size,
                cameraId: id,
                fullness: updatedData.fullness,
                lastUpdate: updatedData.lastUpdate,
                customerName: updatedData.customerName
            }
        }, await withAuth({ 'Content-Type': 'application/json', 'Accept': 'application/json' }));
        return response.data;
    } catch (error) {
        throw new Error(error.response ? `HTTP error! status: ${error.response.status}` : error.message);
    }
};

const patchContainer = async (id, updatedData) => {
    try {
        const response = await axios.patch(`${API_URL}/${id}`, {
            containerId: id,
            data: updatedData
        }, await withAuth({ 'Content-Type': 'application/json', 'Accept': 'application/json' }));
        return response.data;
    } catch (error) {
        throw new Error(error.response ? `HTTP error! status: ${error.response.status}` : error.message);
    }
};

const createContainer = async (id, updatedData) => {
    try {
        const response = await axios.post(API_URL, {
            containerId: id,
            data: {
                geo: updatedData.geo,
                thumbnail: updatedData.thumbnail,
                address: updatedData.address,
                size: updatedData.size,
                cameraId: id,
                fullness: updatedData.fullness,
                lastUpdate: updatedData.lastUpdate,
                customerName: updatedData.customerName
            }
        }, await withAuth({ 'Content-Type': 'application/json', 'Accept': 'application/json' }));
        return response.data;
    } catch (error) {
        throw new Error(error.response ? `HTTP error! status: ${error.response.status}` : error.message);
    }
};

export { fetchContainerData, deleteContainer, updateContainer, createContainer, patchContainer };
